import React from 'react';

export const RTL_LANGUAGES = new Set(['ar']);

function Inline({ text }) {
  return text.split(/(\*\*[^*]+\*\*|\*[^*\s][^*]*\*)/g).map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={index}>{part.slice(1, -1)}</em>;
    }
    return part;
  });
}

const tableCells = (line) => line.trim().replace(/^\||\|$/g, '').split('|').map((cell) => cell.trim());

function ReadingText({ text, lang, dir }) {
  const blocks = [];
  let paragraph = [];
  let list = null;
  let table = null;
  const flush = () => {
    if (paragraph.length) blocks.push({ type: 'p', text: paragraph.join(' ') });
    if (list) blocks.push({ type: 'ul', items: list });
    if (table) blocks.push({ type: 'table', rows: table });
    paragraph = [];
    list = null;
    table = null;
  };
  text.split('\n').forEach((raw) => {
    const line = raw.trim();
    if (line.startsWith('## ') || line.startsWith('### ')) {
      flush();
      const level = line.startsWith('### ') ? 'h4' : 'h3';
      blocks.push({ type: level, text: line.replace(/^#+\s*/, '') });
    } else if (/^[-*] /.test(line)) {
      if (!list) flush();
      list = list || [];
      list.push(line.slice(2));
    } else if (line.startsWith('|')) {
      if (!table) flush();
      table = table || [];
      if (!/^\|[\s:|-]+\|?$/.test(line)) table.push(tableCells(line));
    } else if (!line) {
      flush();
    } else {
      if (list || table) flush();
      paragraph.push(line);
    }
  });
  flush();
  return (
    <div className="birth-reading-body" lang={lang} dir={dir}>
      {blocks.map((block, index) => {
        if (block.type === 'h3') return <h3 key={index}><Inline text={block.text} /></h3>;
        if (block.type === 'h4') return <h4 key={index}><Inline text={block.text} /></h4>;
        if (block.type === 'ul') {
          return (
            <ul key={index}>
              {block.items.map((item, itemIndex) => <li key={itemIndex}><Inline text={item} /></li>)}
            </ul>
          );
        }
        if (block.type === 'table') {
          const [head, ...rows] = block.rows;
          return (
            <div key={index} className="birth-reading-table">
              <table>
                <thead>
                  <tr>{head.map((cell, cellIndex) => <th key={cellIndex}><Inline text={cell} /></th>)}</tr>
                </thead>
                <tbody>
                  {rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, cellIndex) => <td key={cellIndex}><Inline text={cell} /></td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        return <p key={index}><Inline text={block.text} /></p>;
      })}
    </div>
  );
}

export function wrapReading(text, language) {
  return (
    <ReadingText
      text={text}
      lang={language}
      dir={RTL_LANGUAGES.has(language) ? 'rtl' : undefined}
    />
  );
}

export default ReadingText;
